<div class="container mt-3">
    @if (!access) {
        <div class="loading">
            <mat-spinner diameter="32"></mat-spinner>
        </div>
    } @else {
        <h1>Toegang aanvragen</h1>

        @if (access.status === 'active') {
            <p>Je hebt al toegang tot dit project.</p>
            <a [routerLink]="projectLink" class="button">Bekijk project</a>
        } @else {
            <p>
                @if (access.status === 'pending') {
                    Je aanvraag staat klaar. Je krijgt bericht zodra je toegang hebt gekregen.
                } @else {
                    Vraag hieronder toegang aan tot dit project. Je aanvraag wordt direct klaargezet voor de personen
                    die je toegang kunnen geven.
                }
            </p>

            @if (access.status === 'none') {
                <button
                    (click)="requestAccess()"
                    [disabled]="requesting"
                    color="primary"
                    mat-raised-button
                    type="button">
                    Toegang aanvragen
                </button>
            }

            <h2 class="mt-4">Wie kan je toegang geven?</h2>
            <p class="mb-2">
                <small>
                    Deze aanvraag staat al klaar voor deze personen. De namen hieronder zijn er alleen zodat je weet bij
                    wie je terecht kunt als je nog geen toegang hebt gekregen.
                </small>
            </p>
            @if (access.granted_by === undefined) {
                <div class="loading">
                    <mat-spinner diameter="32"></mat-spinner>
                </div>
            } @else if (access.granted_by.length === 0) {
                <p class="empty-message">Er is nog niemand die toegang kan verlenen voor dit project.</p>
            } @else {
                <ul>
                    @for (person of access.granted_by; track person.id) {
                        <li>{{ person.name }}</li>
                    }
                </ul>
            }
        }
    }
</div>
